export default class UrlParams {
    constructor(search,type) {
       this.qs = (search);
       this.params = {};
       if (type === 0) {
         this.parseQuerstring()
       }
       
    }
    parInts(search,isInt1,isInt2,isInt3) {
         this.parseQuerstring(isInt1,isInt2,isInt3);
         return this.params;  
   }
    parseQuerstring(isInt1 =null,isInt2 =null ,isInt3=null) {
      if (this.qs) {

       let str = this.qs
       str.split('&').reduce((a, b) => {
         let [key, val] = b.split('=');
         if (key === isInt1 || key === isInt2 || key === isInt3) {
            if (isNaN(parseInt(val))) {
               throw  'Parameter is not a number!';
            }
            else a[key] = parseInt(val)
         }
         else a[key] = val?.toLowerCase()
         return a;
       }, this.params);
      }
    }
    get(key) {
       return this.params[key];
    }
    getAll(){
       return this.params
    }
  }